// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  User,
  TruckFast,
  Book,
  TrendUp,
  CallCalling,
  Routing2,
  ImportSquare,
  DocumentCopy,
  NoteText
} from "iconsax-react";

// type
import { NavItemType } from "types/menu";

// icons
const icons = {
  customer: User,
  followUps: CallCalling,
  lead: TrendUp,
  contact: Book,
  supplier: TruckFast,
  source: ImportSquare,
  proposalTemplate: DocumentCopy,
  stage: Routing2,
  survey: NoteText,
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const crm: NavItemType = {
  id: "group-crm",
  title: <FormattedMessage id="crm" />,
  icon: icons.contact,
  type: "collapse",
  // url: '/crm/leads',
  breadcrumbs: true,
  permissions: ["NL_CRM_R"],
  children: [
    {
      id: "leads",
      title: <FormattedMessage id="leads" />,
      type: "item",
      url: "/crm/leads",
      icon: icons.lead,
      breadcrumbs: true,
      permissions: ['NL_CRM_LEADS_R', 'NL_CRM_LEADS_C', 'NL_CRM_LEADS_U', 'NL_CRM_LEADS_D', 'NL_CRM_LEADS_L', 'NL_CRM_LEADS_U_ST'],
      children: [
        {
          id: "new-lead",
          title: <FormattedMessage id="new-lead" />,
          type: "item",
          url: "/crm/leads/new-lead",
          icon: icons.lead,
          breadcrumbs: true,
        },
        {
          id: "new-lead",
          title: <FormattedMessage id="new-lead" />,
          type: "item",
          url: "/crm/leads/new-kanban-lead/:life_stage",
          icon: icons.lead,
          breadcrumbs: true,
        },
        {
          id: "edit-lead",
          title: <FormattedMessage id="edit-lead" />,
          type: "item",
          url: "/crm/leads/edit-lead/:id",
          icon: icons.lead,
          breadcrumbs: true,
        },
        {
          id: "lead-survey",
          title: <FormattedMessage id="lead-survey" />,
          type: "item",
          url: "/crm/leads/:lead_id/survey",
          icon: icons.lead,
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "survey",
      title: <FormattedMessage id="survey" />,
      type: "item",
      url: "/crm/survey",
      icon: icons.survey,
      permissions: ['NL_CRM_SURVEY_R', 'NL_CRM_SURVEY_C', 'NL_CRM_SURVEY_U', 'NL_CRM_SURVEY_D', 'NL_CRM_SURVEY_L', 'NL_CRM_SURVEY_U_ST'],
      breadcrumbs: true,
    },
    {
      id: "follow-ups",
      title: <FormattedMessage id="follow-ups" />,
      type: "item",
      url: "/crm/follow-ups",
      icon: icons.followUps,
      permissions: ['NL_CRM_FOLLOW_UPS_R', 'NL_CRM_FOLLOW_UPS_C', 'NL_CRM_FOLLOW_UPS_U', 'NL_CRM_FOLLOW_UPS_D', 'NL_CRM_FOLLOW_UPS_L', 'NL_CRM_FOLLOW_UPS_U_ST'],
      breadcrumbs: true,
    },
    {
      id: "life-stage",
      title: <FormattedMessage id="life-stage" />,
      type: "item",
      url: "/crm/life-stage",
      icon: icons.stage,
      breadcrumbs: true,
      permissions: ['NL_CRM_LIFE_STAGES_R', 'NL_CRM_LIFE_STAGES_C', 'NL_CRM_LIFE_STAGES_U', 'NL_CRM_LIFE_STAGES_D', 'NL_CRM_LIFE_STAGES_L', 'NL_CRM_LIFE_STAGES_U_ST']
    },
    {
      id: "sources",
      title: <FormattedMessage id="sources" />,
      type: "item",
      url: "/crm/sources",
      icon: icons.source,
      breadcrumbs: true,
      permissions: ['NL_CRM_SOURCES_R', 'NL_CRM_SOURCES_C', 'NL_CRM_SOURCES_U', 'NL_CRM_SOURCES_D', 'NL_CRM_SOURCES_L', 'NL_CRM_SOURCES_U_ST']
    },
    {
      id: "customers",
      title: <FormattedMessage id="customers" />,
      type: "item",
      url: "/crm/customers",
      icon: icons.customer,
      breadcrumbs: true,
      permissions: ['NL_CRM_CUSTOMERS_R', 'NL_CRM_CUSTOMERS_C', 'NL_CRM_CUSTOMERS_U', 'NL_CRM_CUSTOMERS_D', 'NL_CRM_CUSTOMERS_L', 'NL_CRM_CUSTOMERS_U_ST'],
    },
    {
      id: "supplier",
      title: <FormattedMessage id="supplier" />,
      type: "item",
      url: "/crm/supplier",
      icon: icons.supplier,
      breadcrumbs: true,
      permissions: ['NL_CRM_SUPPLIERS_R', 'NL_CRM_SUPPLIERS_C', 'NL_CRM_SUPPLIERS_U', 'NL_CRM_SUPPLIERS_D', 'NL_CRM_SUPPLIERS_L', 'NL_CRM_SUPPLIERS_U_ST'],

      children: [
        {
          id: "new-proposal",
          title: <FormattedMessage id="new-proposal" />,
          type: "item",
          url: "/crm/supplier/new-supplier",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
        {
          id: "edit-proposal",
          title: <FormattedMessage id="edit-proposal" />,
          type: "item",
          url: "/crm/supplier/edit-supplier/:id",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
      ],
    },

    {
      id: "proposal",
      title: <FormattedMessage id="proposal" />,
      type: "item",
      url: "/crm/proposal",
      icon: icons.proposalTemplate,
      breadcrumbs: true,
      permissions: ['NL_CRM_PROPOSAL_R', 'NL_CRM_PROPOSAL_C', 'NL_CRM_PROPOSAL_U', 'NL_CRM_PROPOSAL_D', 'NL_CRM_PROPOSAL_L', 'NL_CRM_PROPOSAL_U_ST'],
      children: [
        {
          id: "new-proposal",
          title: <FormattedMessage id="new-proposal" />,
          type: "item",
          url: "/crm/proposal/new-proposal",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
        {
          id: "edit-proposal",
          title: <FormattedMessage id="edit-proposal" />,
          type: "item",
          url: "/crm/proposal/edit-proposal/:id",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
      ],
    },
    {
      id: "proposal-template",
      title: <FormattedMessage id="proposal-template" />,
      type: "item",
      url: "/crm/proposal-template",
      icon: icons.proposalTemplate,
      breadcrumbs: true,
      permissions: ['NL_CRM_PROPOSAL_TEMPLATE_R', 'NL_CRM_PROPOSAL_TEMPLATE_C', 'NL_CRM_PROPOSAL_TEMPLATE_U', 'NL_CRM_PROPOSAL_TEMPLATE_D', 'NL_CRM_PROPOSAL_TEMPLATE_L', 'NL_CRM_PROPOSAL_TEMPLATE_U_ST'],
      children: [
        {
          id: "new-proposal-template",
          title: <FormattedMessage id="new-proposal-template" />,
          type: "item",
          url: "/crm/proposal-template/new-proposal-template",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
        {
          id: "edit-proposal-template",
          title: <FormattedMessage id="edit-proposal-template" />,
          type: "item",
          url: "/crm/proposal-template/edit-proposal-template/:id",
          icon: icons.proposalTemplate,
          breadcrumbs: true,
        },
      ],
    },


    // {
    //   id: 'suppliers',
    //   title: <FormattedMessage id="supplier" />,
    //   type: 'item',
    //   url: '/crm/suppliers',
    //   icon: icons.supplier,
    //   breadcrumbs: true
    // },
  ]
};

export default crm;
